import { createContext, useContext, useState } from "react";

const SiteSettingsContext = createContext(null);

const SiteSettingsProvider = ({ children }) => {
  const [uploading, setUploading] = useState(false);
  const [hideGeoJSON, setHideGeoJSON] = useState(false);
  const [deleteDrawing, setDeleteDrawing] = useState(false);

  return (
    <SiteSettingsContext.Provider
      value={{
        uploading,
        setUploading,
        deleteDrawing,
        setDeleteDrawing,
        hideGeoJSON, 
        setHideGeoJSON,
      }}
    >
      {children}
    </SiteSettingsContext.Provider>
  );
};

const useSiteSettingsContext = () => {
  return useContext(SiteSettingsContext);
};

export { SiteSettingsProvider, useSiteSettingsContext };
